<template>
    <div>
        <!--頁首-->
        <Header :header="header"></Header>
        <!--功能列表-->
        <Menulist :menulist="menulist"></Menulist>
        <!--功能列表_RWD-->
        <Menulist_RWD :menulist="menulist"></Menulist_RWD>
        <main class="main">
            <!--網站路徑(麵包屑)-->
            <Sitebar :sider="sider" ></Sitebar>
            <BackToList v-if="id!=''" :back_url="'?PJ_ID='+PJ_ID+'&modal='+modal"></BackToList>
            <div class="incontall inconbox">
                <SideLeft_List :sideleft="sideleft"></SideLeft_List>
                <SideRight_Member_List v-if="id==''" :sideright="sideright" :pagination="pagination" :PJ_ID="PJ_ID"></SideRight_Member_List>
                <SideRight_Member_Content v-else :sideright="sidecontent" :PJ_ID="PJ_ID"></SideRight_Member_Content>
            </div>
            <BackToList v-if="id!=''" :back_url="'?PJ_ID='+PJ_ID+'&modal='+modal"></BackToList>
        </main>
        <!--頁尾-->
        <Footer :footer="footer"></Footer>
        <GoTop></GoTop>
    </div>
</template> 
<script>

import Header from '../../components/default_en/NavBar/Header.vue';
import Menulist from '../../components/default_en/NavBar/Menulist.vue';
import Menulist_RWD from '../../components/default_en/NavBar/Menulist_RWD.vue';
import Sitebar from '../../components/default_en/NavBar/Sitebar.vue';
import SideLeft_List from '../../components/default_en/Content/SideLeft_List.vue'
import SideRight_Member_List from '../../components/default_en/Content/SideRight_Member_List.vue';
import SideRight_Member_Content from '../../components/default_en/Content/SideRight_Member_Content.vue';
import Footer from '../../components/default_en/NavBar/Footer.vue';
import BackToList from '../../components/default_en/Tool/BackToList.vue';
import GoTop from '../../components/default_en/Tool/GoTop.vue';

export default{
    components:{
        Header,        
        Menulist,
        Menulist_RWD,
        Sitebar,
        SideLeft_List,
        SideRight_Member_List,
        SideRight_Member_Content,
        Footer,
        BackToList,
        GoTop,
    },
    data(){
        return {
            //首頁
            header:{
                text1:"Department of Bio-Industry Communication and Development",
                text2:"Member",
                text3:null,
                
            },
            //功能列表 &功能列表_RWD
            menulist:{
                place:"Member",
            },
            //網站路徑(麵包屑)
            sider:{
                index:2,
                type:0,
                list:[
                    {text:"Member" ,url:"/Member"},
                ],
            },
            //左側資料(列表)
            sideleft:{
                title:"Member",
                list:[],
            },
            //右側資料(內容)
            sideright:{
                 table_Class:"memberlistall",
                list_Class:"memberbar",
                list:[],
            },
            sidecontent:{
                table_Class:"membertable",
                list_Class:"memberbar",
                title:"",
                content:"",
            },
            //頁尾
            footer:{

            },
            //頁碼
            pagination: {
                perPage: 10, //一頁幾筆
                page: 1, //目前第幾筆
                rows: 5, //一次顯示幾頁
            },
            //編號
            id:"",
            //標題名稱
            title:"",
            //類別編號
            PJ_ID:"",
            //文章編號,
            type_id:"",
            //語言
            langurage:"2",
        }
    },
    computed:{

    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
       "$route.query"(){
            //初始化
            this.init();
        },
        "pagination.page"() {
            //初始化
            this.init();
        },
    },
    methods:{
        //初始化
        init(){
            //讀取query參數
            if( this.$route.query){
                //目前頁面編號
                this.PJ_ID = this.$route.query.PJ_ID? this.$route.query.PJ_ID:"";
                //語言
                this.langurage = this.$route.query.lang? this.$route.query.lang: "2";
                 //目前頁面類型
                this.modal = this.$route.query.modal? this.$route.query.modal:"2";
                //目前頁面編號
                this.id = this.$route.query.id? this.$route.query.id:"";
            }
            //取得目前頁面資訊
            this.getHeader();

        },
        //取得目前頁面資訊
        async getHeader(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"GetHeader_front",
                    member_type_SELECT:{
                        langurage :this.langurage,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/MemberType",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    //匯入類別
                    let left_list = [];
                    jsonData.forEach((item ,index) => {
                        //若query沒有PJ_ID時，設定為第一個
                        if(this.PJ_ID =="" && index == 0){
                            this.PJ_ID = item.PJ_ID;
                        }
                        let list_item = {text:item.etitle, url:"?PJ_ID="+item.PJ_ID + "&modal="+item.modal , selected:this.PJ_ID == item.PJ_ID };
                        if(this.PJ_ID == item.PJ_ID){
                            this.type_id = this.PJ_ID.substring(8,this.PJ_ID.length);
                            //加入麵包屑
                            if(this.sider.list.filter(x => x.text == item.etitle).length == 0){
                                this.sider.list.push({text:item.etitle ,url:null});
                            }
                            this.title = item.etitle;
                        }
                        left_list.push(list_item);
                        
                    });
                    this.sideleft.list = left_list;
                    if(this.id != ""){
                        this.getContent();
                    }else if(this.type_id != ""){
                        this.getList();
                    }
                }
            }catch(err){
                console.log("ErrFunction: getHeader/n "+err);
            }
        },
        //取得目前文章列表資訊
        async getList(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"HOME_LIST",
                    member_SELECT:{
                        typeId: this.type_id,
                        langurage: this.langurage,
                        pageIndex: this.pagination.page,
                        pageSize: this.pagination.perPage,
                    }
                };
                //Token
                let resToken = await this.userRequest.post('bicd/Token');
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/member",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status){
                    let list = [];
                    
                    let jsonData = JSON.parse(json.Data);
                    if (jsonData.outData.length > 0) {
                        jsonData.outData.forEach((x) => {
                            let obj = {
                                title: x.title,
                                url:"?PJ_ID="+this.PJ_ID + "&modal="+this.modal + "&id="+x.id,
                                filepath : x.filePath,
                                content:x.description,
                                onlineDate: x.startDate.split('T')[0],
                            };
                            list.push(obj);
                        });
                    }else {
                        let obj = {
                            title: "",
                            url:"",
                            content: "",
                            NotData: true,
                        };
                        list.push(obj);
                    }
                    this.sideright.list = list;
                    
                    this.pagination.rows = jsonData.totalCount;
                }
            }catch(err){
                console.log("ErrFunction: getList/n " + err);
            }
        },
        //取得目前文章內容資訊
        async getContent(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"GetContent_Front",
                    member_SELECT:{
                        id:this.id,
                        typeId:this.type_id,
                        langurage: this.langurage,
                    }
                };
                //Token
                let resToken = await this.userRequest.post('bicd/Token');
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/Member",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status){
                    let jsonData = JSON.parse(json.Data);
                    if(jsonData){
                        this.sidecontent= {
                            title: jsonData.title,
                            filepath : jsonData.filePath,
                            onlineDate:"",
                            onlinePlace: "",
                            content:jsonData.description,
                        }
                    }else {
                        this.sidecontent ={
                            title: this.title,
                            onlineDate:"",
                            onlinePlace: "",
                            content:"Not Data",
                        }
                    }
                }else{
                    this.sidecontent ={
                        title: this.title,
                        onlineDate:"",
                        onlinePlace: "",
                        content:"Not Data",
                    }
                }
            }catch(err){
                console.log("ErrFunction: getContent/n " + err);
            }
        }

    },

}
</script>